import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
   faMartiniGlass, faParking, faSun, faBellConcierge,
   faWaterLadder, faGlasses, faWifi, faBurger, faElevator, faShower, faCouch,
   faUmbrellaBeach, faExpand, faDumbbell, faVideo, faUsers, faTreeCity,
   faChair, faFireFlameCurved, faWind, faLightbulb, faHouse, faSpa, faCampground, faFire, faSeedling,
   faMountainSun, faHorse, faPhone, faLock, faWater, faHotel, faStar, faBolt, faShirt, faChevronDown, faChevronUp, faShop, faBath, faWineGlass
} from '@fortawesome/free-solid-svg-icons';

import { DevelopmentInfo } from '@interfaces/app';
import { Gallery, GalleryItem, ImageItem } from 'ng-gallery';

@Component({
   selector: 'mnf-project-info-detail',
   templateUrl: './project-info-detail.component.html',
   styleUrls: ['./project-info-detail.component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class ProjectInfoDetailComponent implements OnInit {
   @Input() dev: DevelopmentInfo;
   amenities: { icon: string; title: string; }[];
   investmentOpportunity: any;

   faStar = faStar;

   icons = {
      // Huerto
      airConditioning: faWind, // Icono aire acondicionado
      bathroom: faBath, // Icono baño
      beach: faUmbrellaBeach, // Icono playa
      beachClub: faUmbrellaBeach, // Icono club de playa
      bolt: faBolt,
      camping: faCampground, // Icono campana
      commonAreas: faChair,
      couch: faCouch,
      coworking: faUsers,
      elevator: faElevator, // Icono elevador
      flame: faFireFlameCurved,
      grill: faBurger,
      gym: faDumbbell, // Icono gimnasio
      horse: faHorse, // Icono caballo
      hotel: faHotel, // Icono hotel
      house: faHouse,   // Icono casa
      laundry: faShirt,
      light: faLightbulb,
      lock: faLock, // Icono cerradura
      lounge: faMartiniGlass,
      lounger: faUmbrellaBeach,
      mountain: faMountainSun, // Icono montaña
      net: faExpand,
      parking: faParking, // Icono estacionamiento
      phone: faPhone, // Icono teléfono
      pool: faWaterLadder, // Icono alberca
      reception: faBellConcierge, // Icono recepción
      roof: faGlasses, // Icono techo
      seedling: faSeedling,
      shops: faShop,
      shower: faShower,
      solarium: faSun,
      spa: faSpa, // Icono spa
      terrace: faTreeCity, // Icono terraza
      vigilance: faVideo, // Icono vigilancia
      water: faWater, // Icono agua
      wifi: faWifi, // Icono wifi
      barDrink: faWineGlass, // Icono bar
      bar: faWineGlass
   };

   datosProcesados: any;

   devDescription: SafeHtml;

   galleryId = 'myLightbox';
   images: GalleryItem[] = [];

   /** Iconos para el collpase */
   iconShow = faChevronDown;
   iconHide = faChevronUp;
   collapseStates: boolean[] = [];

   constructor(private domSanitizer: DomSanitizer, private gallery: Gallery) { }

   ngOnInit(): void {
      this.devDescription = this.domSanitizer.bypassSecurityTrustHtml(this.dev?.description);
      this.loadGallery();

      this.amenities = this.dev?.features?.amenities?.map(a => { const o = a.split('|'); return { title: o[0], icon: o[1] } });

      if(this.dev?.devInfoDetail?.monthsEstimateResidential) {
         let array = this.dev?.devInfoDetail?.monthsEstimateResidential;
         this.datosProcesados = array.map(item => {
            const partes = item.split('|');
            return {
              duracion: partes[0],
              rendimientoAnual: partes[1],
              rendimientoTotal: partes[2]
            };
          });
      }
   }

   loadGallery() {
      const galleryRef = this.gallery.ref('myGallery', { loadingStrategy: 'lazy' });
      this.images = (this.dev?.gallery || this.dev?.images)?.map(i => new ImageItem({ src: i, thumb: i }));
      galleryRef.load(this.images);

   }

   /** Función para abrir el enlances externos desde botones */
   openLink(link: string): void {
      window.open(link, '_blank');
   }

   /** Función para obtener el titulo de las preguntas */
   getTitleQuestion(question: string): string {
      const [title] = question.split('|');
      return this.extractInnerHTML(title);
   }

   /** Función para obtener la descripción de las preguntas */
   getDescriptionQuestion(question: string): string {
      const [, description] = question.split('|');
      return this.sanitizeHTML(description);
   }

   /** Función para realizar la función del collapse de los contenedores */
   toggleCollapse(index: number): void {
      this.collapseStates[index] = !this.collapseStates[index];
   }

   /** Función para extraer código HTML del arreglo a partir de un `div` */
   private extractInnerHTML(html: string): string {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      return tempElement.textContent;
   }

   /** Función para extraer cóðigo HTML del arreglo después del `h4` */
   private sanitizeHTML(html: string): string {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      return tempElement.innerHTML;
   }
}
